import * as React from 'react';
import { SVGProps } from 'react';

const IconWrenchSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13.25 7.74a4.525 4.525 0 0 1 1.154-4.42 4.525 4.525 0 0 1 4.383-1.162l-2.562 2.563L16.5 7.5l2.91.4 2.562-2.56a4.523 4.523 0 0 1-5.775 5.483l-.015.013L5.645 21.374a2.133 2.133 0 0 1-3.02 0 2.136 2.136 0 0 1 0-3.02L13.25 7.74Z" />
  </svg>
);
export default IconWrenchSizeM;
